export default "__VITE_ASSET__4cbab3fc__"